module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"officeInterviewRecord":"In-person interview recording"}}')
  delete Component.options._Ctor
}
